(function () {
  function setup(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const cards = Array.from(root.querySelectorAll('[data-promo-card]'));
    const grid = root.querySelector('.bc-promo-grid');
    const scents = [...new Set(cards.map(card => card.dataset.scent))].sort((a,b) => a.localeCompare(b));
    const scentGroup = root.querySelector('[data-promo-scents]');
    const scentKey = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    for (const scent of scents) {
      const button = document.createElement('button');
      button.type = 'button'; button.dataset.promoScent = scentKey(scent); button.textContent = scent; button.setAttribute('aria-pressed','false'); scentGroup.append(button);
    }
    let activeType = 'all', activeScent = 'all';
    const sort = root.querySelector('[data-promo-sort]');
    function readURL() {
      const params = new URL(location.href).searchParams;
      activeType = ['tonic','splash'].includes(params.get('type')) ? params.get('type') : 'all';
      activeScent = scents.some(s => scentKey(s) === params.get('scent')) ? params.get('scent') : 'all';
      sort.value = ['price-asc','price-desc','title'].includes(params.get('order')) ? params.get('order') : 'featured';
    }
    function apply(save = false) {
      let count = 0;
      const ordered = [...cards].sort((a,b) => {
        const stock = Number(b.dataset.available === 'true') - Number(a.dataset.available === 'true');
        if (stock) return stock;
        if (sort.value === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
        if (sort.value === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
        if (sort.value === 'title') return a.dataset.scent.localeCompare(b.dataset.scent);
        return Number(a.dataset.order) - Number(b.dataset.order);
      });
      ordered.forEach(card => {
        card.hidden = (activeType !== 'all' && card.dataset.kind !== activeType) || (activeScent !== 'all' && scentKey(card.dataset.scent) !== activeScent);
        if (!card.hidden) count++;
        grid.append(card);
      });
      root.querySelectorAll('[data-promo-type]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.promoType === activeType)));
      root.querySelectorAll('[data-promo-scent]').forEach(b => {
        b.setAttribute('aria-pressed', String(b.dataset.promoScent === activeScent));
        b.disabled = b.dataset.promoScent !== 'all' && !cards.some(c => (activeType === 'all' || c.dataset.kind === activeType) && scentKey(c.dataset.scent) === b.dataset.promoScent);
      });
      root.querySelector('[data-promo-count]').textContent = root.dataset.count.replace('[count]', count).replace('[total]', cards.length);
      root.querySelector('.bc-promo-empty').hidden = count > 0;
      if (save) {
        const url = new URL(location.href);
        for (const [key,value] of [['type',activeType],['scent',activeScent],['order',sort.value]]) {
          if (value === 'all' || value === 'featured') url.searchParams.delete(key); else url.searchParams.set(key,value);
        }
        history.replaceState(null,'',url);
      }
    }
    function scrollToShop() {
      const target = root.querySelector('.bc-promo-shop');
      target.focus({preventScroll:true});
      target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',block:'start'});
    }
    root.querySelectorAll('[data-promo-controls]').forEach(el => el.hidden = false);
    root.addEventListener('click', event => {
      const type = event.target.closest('[data-promo-type]'), scent = event.target.closest('[data-promo-scent]'), jump = event.target.closest('[data-promo-jump]');
      if (type) {
        activeType = type.dataset.promoType;
        if (!cards.some(c => (activeType === 'all' || c.dataset.kind === activeType) && scentKey(c.dataset.scent) === activeScent)) activeScent = 'all';
        apply(true);
      }
      if (scent) {activeScent = scent.dataset.promoScent; apply(true);}
      if (event.target.closest('[data-promo-reset]')) {activeType = activeScent = 'all'; apply(true);}
      if ((jump || event.target.closest('[data-promo-scroll]')) && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0) {
        event.preventDefault();
        if (jump) {activeType = jump.dataset.promoJump; activeScent = 'all'; apply(true);}
        scrollToShop();
      }
    });
    async function openMonsterCart() {
      for (let attempt = 0; attempt < 15; attempt++) {
        if (typeof window.monster_refresh === 'function') {
          try {
            await window.monster_refresh(true);
            return true;
          } catch (error) { return false; }
        }
        await new Promise(resolve => setTimeout(resolve, 200));
      }
      return false;
    }
    async function addBottle(button) {
      if (button.disabled) return;
      const status = button.closest('[data-promo-card]').querySelector('[data-promo-status]');
      button.disabled = true; button.setAttribute('aria-busy','true'); status.textContent = '';
      try {
        const response = await fetch(root.dataset.cartAdd + '.js', {method:'POST',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(button.dataset.promoAdd),quantity:1}]})});
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || root.dataset.error);
        status.textContent = root.dataset.added;
        root.querySelector('[data-promo-cart]').hidden = false;
        await openMonsterCart();
        fetch(root.dataset.cartUrl + '.js', {headers:{Accept:'application/json'}}).then(r => r.json()).then(cart => {
          document.querySelectorAll('#cart-count > .count, .cart-item-count').forEach(el => el.textContent = cart.item_count);
        }).catch(() => {});
      } catch(error) {status.textContent = error.message || root.dataset.error;}
      finally {button.disabled = false; button.removeAttribute('aria-busy');}
    }
    root.addEventListener('click', async event => {
      const link = event.target.closest('[data-promo-cart] a');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault(); event.stopImmediatePropagation();
      if (!await openMonsterCart()) window.location.assign(link.href);
    }, true);
    root.querySelectorAll('[data-promo-add]').forEach(button => {
      button.disabled = false;
      button.addEventListener('click', event => {event.preventDefault(); event.stopPropagation(); addBottle(button);});
    });
    sort.addEventListener('change', () => apply(true));
    window.addEventListener('popstate', () => {readURL(); apply();});
    readURL(); apply();
  }
  function init() {document.querySelectorAll('[data-promo-root]').forEach(setup);}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();
